import Immutable from "immutable";
import { createAlert } from "actions/alerts";
import { closeModal } from "actions/modal";
import { AsyncAction } from "actions/types";

export function patchBillingPlan(payload: Immutable.Map<string, unknown>): AsyncAction {
  return (dispatch, getState) => {
    const availablePlans: Immutable.Map<string, unknown>[] = (
      getState().billingPlan.getIn(["record", "availablePlans"])
    );

    const newPlan = availablePlans.find(plan => plan.get("planId") === payload.getIn(["plan", "planId"]));

    dispatch({
      CALL_API: {
        method: "patch",
        endpoint: "/billings/plan/",
        payload: {
          plan_id: payload.getIn(["plan", "planId"])
        },
        types: ["UPDATE_PLAN_REQUEST", "UPDATE_PLAN_SUCCESS", "UPDATE_PLAN_FAILURE"],
        args: {
          plan: newPlan
        },
        dispatchCallbacks: [
          {
            request: createAlert,
            fireOnStatus: "success",
            args: {
              message: "Your plan has been successfully changed.",
              alertType: "success"
            }
          },
          {
            request: closeModal,
            fireOnStatus: "success"
          }
        ]
      }
    });
  };
}
